<template>
  <div>
    <span class="title">方案基础信息</span>
    <ul class="info-wapper">
      <li>
        <div>
          <label>提成与折算业绩方案名称</label>
          <span>{{ info.planName }}</span>
        </div>
        <div v-if="!status">
          <label >方案标识</label>
          <span>{{ info.id }}</span>
        </div>
      </li>
      <li>
        <div>
          <label>经理审批线</label>
          <span>{{ info.managerLine || '' }}</span>
        </div>
        <div>
          <label>总监审批线</label>
          <span>{{ info.directorLine || '' }}</span>
        </div>
      </li>
      <li>
        <div>
          <label>禁止销售线</label>
          <span>{{ info.saleLine || '' }}</span>
        </div>
        <div>
          <label>折算业绩线</label>
          <span>{{ info.conversionLine }}</span>
        </div>
      </li>
      <!-- <li v-if="!status">
        <div>
          <label>特殊提成基准值</label>
          <span>{{ Number(info.royaltySpecialValue).toFixed(2) }}</span>
        </div>
      </li> -->
      <li v-if="!status">
        <div>
          <label>创建人</label>
          <span>{{ info.creatorName }}</span>
        </div>
        <div>
          <label>创建时间</label>
          <span>{{ info.gmtCreate }}</span>
        </div>
      </li>
      <li v-if="!status">
        <div>
          <label>最后修改人</label>
          <span>{{ info.operatorName }}</span>
        </div>
        <div>
          <label>最后修改时间</label>
          <span>{{ info.gmtModified }}</span>
        </div>

      </li>
      <li v-if="!status">
        <div >
          <label>提成方案状态</label>
          <span>{{ info.stateName }}</span>
        </div>
      </li>
      <li>
        <div class="special">
          <label>备注说明</label>
          <span class="textarea">{{ info.remarks }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['info','status']
}
</script>

<style>
.header {
  margin-bottom: 15px;
}

.content-wapper {
  border: 1px solid #d6dbe5;
  border-radius: 3px;
  padding: 30px;
  padding-top: 15px;
  background: #fff;
}
.info-wapper{
  border-top: 1px dashed #909399
}
.info-wapper li {
  margin: 15px 0;
}

.info-wapper div {
  display: inline-block;
  width: 500px;
  position: relative;
}

.info-wapper .special {
  width: 800px;
}

.info-wapper span {
  margin-left: 150px;
}

.info-wapper label {
  color: #909399;
  display: inline-block;
  width: 133px;
  text-align: right;
  position: absolute;
  top: 0;
}

.textarea {
  display: inline-block;
  width: 500px;
}

.title {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 30px 0 10px 0;
}
</style>